<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    variant?: 'gradient' | 'white'
    animate?: boolean
  }>(),
  {
    variant: 'gradient',
    animate: false
  }
)

const gradientId = useId()
</script>

<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 31 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <defs v-if="props.variant === 'gradient'">
      <linearGradient :id="gradientId" x1="0" y1="29" x2="31" y2="0" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stop-color="rgb(var(--color-blue))" />
        <stop offset="50%" stop-color="rgb(var(--color-green))" />
        <stop offset="100%" stop-color="rgb(var(--color-yellow))" />
      </linearGradient>
    </defs>

    <g :fill="props.variant === 'gradient' ? `url(#${gradientId})` : 'currentColor'">
      <path
        :class="{ 'tw-animate-pulse': props.animate }"
        d="M11.1765 11.8242C11.1765 11.8242 16.3513 11.7048 18.5652 9.49095C20.779 7.27713 20.8984 2.10225 20.8984 2.10225C20.8984 2.10225 21.0179 7.27713 23.2317 9.49095C25.4455 11.7048 30.6204 11.8242 30.6204 11.8242C30.6204 11.8242 25.4455 11.9437 23.2317 14.1575C21.0179 16.3713 20.8984 21.5462 20.8984 21.5462C20.8984 21.5462 20.779 16.3713 18.5652 14.1575C16.3513 11.9437 11.1765 11.8242 11.1765 11.8242Z"
      />
      <path
        :class="{ 'tw-animate-pulse': props.animate }"
        style="animation-delay: 0.2s !important"
        d="M0 6.60864C0 6.60864 3.51766 6.52744 5.02251 5.02259C6.52737 3.51773 6.60857 7.1467e-05 6.60857 7.1467e-05C6.60857 7.1467e-05 6.68977 3.51773 8.19463 5.02259C9.69948 6.52744 13.2171 6.60864 13.2171 6.60864C13.2171 6.60864 9.69948 6.68984 8.19463 8.1947C6.68977 9.69956 6.60857 13.2172 6.60857 13.2172C6.60857 13.2172 6.52737 9.69956 5.02251 8.1947C3.51766 6.68984 0 6.60864 0 6.60864Z"
      />
      <path
        :class="{ 'tw-animate-pulse': props.animate }"
        style="animation-delay: 0.4s !important"
        d="M3.29975 21.4575C3.29975 21.4575 6.81741 21.3763 8.32227 19.8715C9.82712 18.3666 9.90832 14.8489 9.90832 14.8489C9.90832 14.8489 9.98952 18.3666 11.4944 19.8715C12.9992 21.3763 16.5169 21.4575 16.5169 21.4575C16.5169 21.4575 12.9992 21.5387 11.4944 23.0436C9.98952 24.5484 9.90832 28.0661 9.90832 28.0661C9.90832 28.0661 9.82712 24.5484 8.32227 23.0436C6.81741 21.5387 3.29975 21.4575 3.29975 21.4575Z"
      />
    </g>
  </svg>
</template>
